import { api } from "@api/api";

export async function deletePlanMapOptionService(id: number): Promise<void> {
  await api.delete(`/v1/integration_plan_map_option_admin/${id}/`);
}
